
import enterView from 'enter-view';


enterView({
	selector: '.section-intro p, .gallery-grid__content p, .section-main-heading h1, .section-your-visit-header h1, .section-about-us-header__desc, .section-space-hire-header h1',
	enter: function(el) {
		el.classList.add('ev-entered');
	},
	offset: 0.2, // enter at middle of viewport
	once: false, // trigger just once
});

